import apiGroupsTrainers from '@/api/groups-trainers'

const state = {
  data: [],
  isLoading: false,
  error: null,
}

export const mutationTypes = {
  getGroupsTrainersStart: '[groups trainers] Get groups trainers start',
  getGroupsTrainersSuccess: '[groups trainers] Get groups trainers success',
  getGroupsTrainersFailure: '[groups trainers] Get groups trainers failure',

  getGroupsTrainersIdsStart: '[groups trainers] Get groups trainers ids start',
  getGroupsTrainersIdsSuccess:
    '[groups trainers] Get groups trainers ids success',
  getGroupsTrainersIdsFailure:
    '[groups trainers] Get groups trainers ids failure',
}

export const actionTypes = {
  getGroupsTrainers: '[groups trainers] Get groups trainers',
  getGroupsTrainersIds: '[groups trainers] Get groups trainers ids',
}

const mutations = {
  [mutationTypes.getGroupsTrainersStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getGroupsTrainersSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getGroupsTrainersFailure](state) {
    state.isLoading = false
  },

  [mutationTypes.getGroupsTrainersIdsStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getGroupsTrainersIdsSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getGroupsTrainersIdsFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.getGroupsTrainers](context, {groupId}) {
    context.commit(mutationTypes.getGroupsTrainersStart)
    return new Promise((resolve) => {
      apiGroupsTrainers
        .getGroupsTrainers(groupId)
        .then((response) => {
          context.commit(mutationTypes.getGroupsTrainersSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getGroupsTrainersFailure)
        })
    })
  },

  [actionTypes.getGroupsTrainersIds](context, {groupIds}) {
    context.commit(mutationTypes.getGroupsTrainersIdsStart)

    return new Promise((resolve) => {
      const getGroupsTrainersIds = async (groupIds) => {
        let result = []
        for (const groupId of groupIds) {
          await context
            .dispatch(actionTypes.getGroupsTrainers, {groupId})
            .then((res) => (result = [...result, ...res]))
        }
        return result
      }
      getGroupsTrainersIds(groupIds)
        .then((response) => {
          context.commit(mutationTypes.getGroupsTrainersIdsSuccess, response)
          resolve(response)
        })
        .catch(() => {
          context.commit(mutationTypes.getGroupsTrainersIdsFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
